import * as Types from '../constants/actionTypes';
const defaultState = {
    isPending: false,
    releaseNoteList: [],
    error: ''
}
export default (state = defaultState, action) => {
    switch (action.type) {
        /* Box Details States */
        case Types.RELEASE_NOTE_DETAIL_SUCCESS:
            return {
                ...state,
                releaseNoteList: action.payload
            }
        case Types.RELEASE_NOTE_ADDED_SUCCESS:
            state.releaseNoteList.push(action.payload)
            return {
                ...state
            }
        case Types.RELEASE_NOTES_DELETED_SUCCESS:
            const newList = state.releaseNoteList.filter((releaseNotes) => releaseNotes.id !== action.payload)
            return {
                ...state,
                releaseNoteList: newList,
                deletedStatus: action.payload
            }
        case Types.LIST_ALL_RELEASE_NOTES:
            return {
                ...state,
                allReleaseNote: action.allReleaseNote
            }
        case Types.RELEASE_NOTE_ERROR:
            return {
                ...state,
                releaseNoteError: action.releaseNoteError
            }
        case Types.RELEASE_NOTES_UPDATED_SUCCESS:
            const updateIndex = state.releaseNoteList.findIndex((data) => { return data.id === action.payload.id });
            if (updateIndex > -1) {
                state.releaseNoteList[action.updateIndex] = action.payload
            }
            return {
                ...state,
            }
        case Types.ADD_RELEASE_NOTES_REFERENCE_FILE_SUCCESS:
            return {
                ...state,
                releaseNotesaddedFileDetails: action.addedFile
            }
        case Types.ADD_RELEASE_NOTES_REFERENCE_FILE_ERROR:
            return {
                ...state,
                releaseNotesaddedFileError: action.error
            }
        case Types.GET_RELEASE_NOTES_REFERENCE_FILE_SUCCESS:
            return {
                ...state,
                releaseNotesFetchedFileDetails: action.fetchFileDetails
            }
        case Types.GET_RELEASE_NOTES_REFERENCE_FILE_ERROR:
            return {
                ...state,
                releaseNotesFetchedFileError: action.error
            }
        case Types.DELETE_RELEASE_NOTES_REFERENCE_FILE_SUCCESS:
            return {
                ...state,
                releaseNotesDeleteFileDetails: action.deleteFileDetails
            }
        case Types.DELETE_RELEASE_NOTES_REFERENCE_FILE_ERROR:
            return {
                ...state,
                releaseNotesDeleteFileError: action.error
            }
        case Types.RELEASE_NOTE_COUNT_SUCCESS:
            return Object.assign({}, state, { releaseNoteInfoCount: action.payload })
        default:
            return state
    }
}
